import { getSensors } from "@/api/device/sensor";
import TnMessage from "@/global/components/message";
import { Sensor } from "@/global/interface/device/sensor";
import { graphicStore } from "@/global/store/graphic-store";
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import SensorPopWindow from "./sensor-pop-window/sensor-pop-window";
import './index.less'
import { emitter } from "@/global/listeners";
import { Emit_Event } from "@/enums/emit-event";
import { MonitorParameter } from "@/global/interface/monitor-object/monitor-parameter";

/**
 * 为直接参数匹配传感器时，图形区展示传感器的参数面板，以供选择
 */
export default function SensorParamPop() {
    const { projectId } = useParams(); // 项目id
    const [sensors, setSensors] = useState<Sensor[]>([]); // 满足条件的传感器
    const [param, setParam] = useState<MonitorParameter>(); // 要为此参数匹配传感器

    useEffect(() => {
        // 监听要匹配传感器的信号
        emitter.on(Emit_Event.MATCH_SENSOR, querySensors);
        // 监听匹配完成的信号
        emitter.on(Emit_Event.MATCH_SENSOR_FINISH, clear);
        return () => {
            emitter.off(Emit_Event.MATCH_SENSOR, querySensors);
            emitter.off(Emit_Event.MATCH_SENSOR_FINISH, clear);
        }
    }, [projectId])

    // 查询能返回特定参数的传感器
    const querySensors = (param: MonitorParameter) => {
        if (!param) return;
        setParam(param);
        let globalParameterId = param.globalMonitorParameterId;
        getSensors(+projectId, { globalParameterId: globalParameterId }).then(res => {
            let sensors: Sensor[] = res.data || [];
            const editor = graphicStore.extraContext.getCurrentViewEditor();
            sensors = sensors.map(sensor => {
                // 传感器图元uuid
                let primitiveUuid = sensor.primitiveUuid;
                // 传感器图元
                let entity = editor.entityDict[primitiveUuid];
                return {
                    ...sensor,
                    entity: entity
                }
            })
            setSensors(sensors);
        }).catch(err => {
            TnMessage.error("获得传感器信息失败")
        })
    }

    // 匹配结束
    const clear = () => {
        setSensors([]);
    }

    return (
        <div className="sensor-param-pop-container">
            {sensors.map(sensor => (
                <SensorPopWindow param={param} entity={sensor.entity} sensor={sensor} />
            ))}
        </div>
    )
}